module.exports = {"321283001":"济川街道","321283100":"黄桥镇","321283101":"分界镇","321283102":"古溪镇","321283104":"元竹镇","321283105":"珊瑚镇","321283106":"广陵镇","321283108":"曲霞镇","321283109":"张桥镇","321283112":"河失镇","321283113":"新街镇","321283114":"姚王镇","321283115":"宣堡镇","321283123":"滨江镇","321283124":"虹桥镇","321283200":"根思乡","321283401":"市农科所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321283.json
// module id = 859
// module chunks = 0